import CXMApiClient from "../CXMApiClient";
import { UserCustomNotificationType } from "../../lib/utilities/enums";
import { getSortedEmails } from "../../lib/utilities/helpers/contact";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    CrmModal: {
      ShowModal: false,
      Description: "",
      type: "",
      modalData: null
    },
    EditHouseholdModal: {
      ShowModal: false,
      Description: "",
      type: "",
      member: null
    },
    DeleteHouseholdModal: {
      ShowModal: false,
      Description: "",
      type: "",
      member: null
    },
    HouseholdErrorModal: {
      ShowModal: false,
      errors: []
    },
    CurrentContact: {},
    LoadingCurrentContact: false,
    ShowResultPanel: true,
    HouseholdMembers: [],
    ContactAssignments: {},
    ContactUserTasks: [],
    printOfferModalInfo: {
      show: false,
      url: null
    },
    CanEditContact: false,
    CanReactivateLead: false,
    CanViewContact: false,
    ContactHasActiveShowroomOrDeliveryVisit: false,
    HouseholdCoBuyerModalInfo: {
      showModal: false,
      data: null
    },
    DuplicateHouseholdMemberModalInfo: {
      showModal: false,
      data: null,
      pageTitle: null
    },
    HouseholdCoBuyerUpdateSpinner: false
  };
}

const state = initialState();

const getters = {
  CurrentContact: function() {
    return state.CurrentContact;
  },
  ContactUserTasks: function() {
    return state.ContactUserTasks;
  },
  printOfferModalInfo: function() {
    return state.printOfferModalInfo;
  },
  CanEditContact: function() {
    return state.CanEditContact;
  },
  CanReactivateLead: function() {
    return state.CanReactivateLead;
  },
  CanViewContact: function() {
    return state.CanViewContact;
  }
};

const actions = {
  setCrmModal(context, val) {
    context.commit("CrmModalShowModal", val);
  },
  setHouseholdErrorModal(context, val) {
    context.commit("HouseholdErrorModalShowModal", val);
  },
  setEditHouseholdModal(context, val) {
    context.commit("EditHouseholdModalShowModal", val);
  },
  setDeleteHouseholdModal(context, val) {
    context.commit("DeleteHouseholdModalShowModal", val);
  },
  setUserContactPermissions(context, val) {
    context.commit("updateUserContactPermissions", val);
  },
  updateContactShowroomOrDeliveryVisitStatus: function(context, data) {
    context.commit("updateContactShowroomOrDeliveryVisitStatus", data);
  },

  getContactHousehold(context, contactId) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    context.commit("updateHouseholdCoBuyerSpinner", true);
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/crm/contacts/" + contactId + "/household",
            null,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              context.commit("updateHouseholdMembers", response.data.data);
              context.commit("updateHouseholdCoBuyerSpinner", false);
              resolve(response);
            } else {
              context.commit("updateHouseholdCoBuyerSpinner", false);
              reject(response);
            }
          })
          .catch(err => {
            context.commit("updateHouseholdCoBuyerSpinner", false);
            reject(err);
          })
      );
    });
  },
  getAssignmentsForContact: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/api/contacts/" + request.contactId + "/assignments",
            null,
            request.scope ? [request.scope] : []
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  saveAssignmentsForContact: function(context, data) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "PUT",
            "/api/contacts/" + data.contactId + "/assignments",
            data.assignments,
            data.scope ? [data.scope] : []
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  getContactAssignmentsForLead: function(context, crmLeadId) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/api/crmlead/" + crmLeadId + "/assignments",
            null,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  saveContactLeadAssignments: function(context, data) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "PUT",
            "/api/crmlead/" + data.crmLeadId + "/assignments",
            data.assignments,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  getContactUserTasks(context, taskSearch) {
    return new Promise(async (resolve, reject) => {
      if (!taskSearch) return;
      let client = new CXMApiClient();
      let payload;
      if (
        taskSearch.entityId &&
        taskSearch.entityId != "" &&
        taskSearch.entityId != "no-vehicle"
      ) {
        payload = {
          entityId: taskSearch.entityId,
          assignedPandoUserId: taskSearch.assignedPandoUserId
        };
      } else {
        payload = {
          contactId: taskSearch.contactId,
          assignedPandoUserId: taskSearch.assignedPandoUserId
        };
      }
      const scope = HelperFunctions.getCurrentCustomerScope();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "/crm/contacts/" + taskSearch.contactId + "/task/search",
            payload,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              context.commit("updateContactUserTasks", response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  getContactById(context, contactId) {
    // Shared action called from multiple places
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("get", "/crm/contacts/" + contactId)
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  updateMarkedAsHot(context, contact) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      let payload = (!contact.isMarkedHot).toString();
      client
        .ProcessRequest(
          "post",
          "/crm/contacts/" + contact.id + "/actions/mark_as_hot",
          payload,
          scope
        )
        .then(response => {
          if (response && response.data.successful) {
            context.commit("updateMarkedAsHot", response.data.data);
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  loadCustomerDashboardInformation(context, contactId) {
    return new Promise((resolve, reject) => {
      context.commit("toggleLoadingCurrentContact", true);
      context
        .dispatch("getContactById", contactId)
        .then(response => {
          context.commit("toggleLoadingCurrentContact", false);
          context.commit("updateCurrentContact", response);
          context.dispatch("loadContactOwnedVehicles", {
            contactId: contactId,
            scope: state.CurrentContact.accountPlatformId
          });
          context.dispatch("loadActivityTypes");
          resolve(response);
        })
        .catch(err => {
          context.commit("toggleLoadingCurrentContact", false);
          reject(err);
        });
    });
  },
  clearContactInformation(context) {
    context.commit("clearContactInformation");
    context.commit("clearContactUserTasks");
    context.commit("clearContactPermissions");
    context.dispatch("clearContactOwnedVehicles");
    context.dispatch("clearAllContactOwnedVehicles");
    context.dispatch("clearCurrentVehicles");
    context.dispatch("setGarageVehicleInfo", null);
    context.dispatch("clearGarageData");
    context.commit("clearServiceSummary");
    context.commit("updateContactShowroomOrDeliveryVisitStatus", null);
    context.dispatch("clearContactRecallData");
    context.commit("updateHouseholdMembers", []);
  },
  saveHouseholdMember(context, contact) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    context.commit("updateHouseholdCoBuyerSpinner", true);
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/crm/contacts/" + contact.contactId + "/household",
          contact.members,
          scope
        )
        .then(response => {
          if (response && response.data.successful)
            context.dispatch("getContactHousehold", state.CurrentContact.id);
          context.commit("updateHouseholdCoBuyerSpinner", false);
          resolve(response.data);
        })
        .catch(err => {
          context.commit("updateHouseholdCoBuyerSpinner", false);
          reject(err.response);
        });
    });
  },
  saveContact(context, contact) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest("post", "/crm/contacts", contact, scope)
          .then(response => {
            if (response && response.data.successful) {
              context.dispatch(
                "loadCustomerDashboardInformation",
                state.CurrentContact.id
              );

              // Notify user
              context.dispatch("sendCustomNotificationToUser", {
                UserId: context.getters.User.UserId,
                Payload: {
                  action: UserCustomNotificationType.CUSTOMER_PROFILE_UPDATE,
                  data: {
                    contactId: contact.id,
                    platformId: contact.accountPlatformId
                  }
                }
              });

              return response.data.successful;
            } else {
              if (!response) {
                reject(response);
              }
              if (!response.data.successful) {
                return response.data.successful;
              } else {
                reject(response);
              }
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  deleteHouseholdMember(context, contactRelationshipId) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "delete",
            "/crm/contacts/" +
              state.CurrentContact.id +
              "/household/" +
              contactRelationshipId,
            null,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              context.dispatch("getContactHousehold", state.CurrentContact.id);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  setShowResultsPanel(context, val) {
    context.commit("updateShowResultsPanel", val);
  },
  setViewDealsheet(context, contact) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "/user_activity_submission/view_dealsheet",
            {
              ContactId: contact.contactId,
              EntityId: contact.entityId
            },
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  setViewProfileSection(context, payload) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "/user_activity_submission/view_profile_section",
            payload,
            scope
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  printProposalPdf: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessBlobRequest(
            "post",
            "api/Dealsheet/entity/" +
              request.entityID +
              "/pdf_proposal_extended",
            request,
            scope
          )
          .then(response => {
            if (response && response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  printOffer: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "api/Dealsheet/entity/" + request.entityIds[0] + "/offer",
            request,
            scope
          )
          .then(response => {
            if (
              response &&
              response.data &&
              response.data.data &&
              response.data.data.success
            ) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  openPrintOfferModal: function(context, request) {
    context.commit("openPrintOfferModal", request);
  },
  caslSMSCheck: function(context, contactId) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/crm/contacts/" + contactId + "/actions/sms/can_text"
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err.response);
          })
      );
    });
  },
  getUserContactPermissions(context, data) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/api/contacts/" +
              data.contactId +
              "/user_permissions/" +
              data.userId
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data.canView);
              if (response.data.data.canView) {
                context.commit(
                  "updateUserContactPermissions",
                  response.data.data
                );
              }
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  clearContactPermissions: function(context) {
    context.commit("clearContactPermissions");
  },
  bulkReassignRole(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("post", "/crm/contacts/bulkReassignRole", request)
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  async getDealsheetInformation(context, requestPayload) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest("POST", "/api/dealsheet/request", requestPayload)
      .catch(err => err.response);
  },
  async logCustomerNote(context, requestPayload) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "POST",
      `/crm/contacts/${requestPayload.contactId}/log_customer_note`,
      requestPayload.payload
    );
    return response && response.data.successful ? response.data : null;
  },
  async getEmailPrintPdf(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    let client = new CXMApiClient();
    const response = await client.ProcessBlobRequest(
      "post",
      `/api/Dealsheet/contact/${request.contactId}/email/printtopdf`,
      request,
      scope
    );

    return response && response.data ? response.data : null;
  },
  updateHouseholdCoBuyerModalInfo(context, data) {
    context.commit("updateHouseholdCoBuyerModalInfo", data);
  },
  updateDuplicateHouseholdMembersModal(context, data) {
    context.commit("updateDuplicateHouseholdMembersModal", data);
  }
};

const mutations = {
  updateContactUserTasks: function(state, data) {
    state.ContactUserTasks = data || [];
  },
  updateCurrentContact: function(state, data) {
    data.emails = getSortedEmails(data.emails);
    state.CurrentContact = data;
  },
  clearContactUserTasks: function(state) {
    state.ContactUserTasks = null;
  },
  clearContactInformation(state) {
    state.CurrentContact = null;
  },
  clearServiceSummary(state) {
    state.ServiceSummary = null;
  },
  clearContactPermissions(state) {
    state.CanEditContact = false;
    state.CanViewContact = false;
    state.CanReactivateLead = false;
  },
  updateMarkedAsHot(state, data) {
    state.CurrentContact.isMarkedHot = data.isMarkedHot;
  },
  toggleLoadingCurrentContact(state, value) {
    state.LoadingCurrentContact = value;
  },
  updateHouseholdMembers: function(state, data) {
    data.forEach(d => (d.contact.emails = getSortedEmails(d.contact.emails)));
    state.HouseholdMembers = data;
  },
  updateContactAssignments: function(state, value) {
    state.ContactAssignments = value;
  },

  updateUserContactPermissions(state, data) {
    state.CanViewContact = data.canView;
    state.CanEditContact = data.canEdit;
  },
  CrmModalShowModal(state, val) {
    state.CrmModal.ShowModal = val.ShowModal;
    state.CrmModal.Description = val.Description;
    state.CrmModal.buttons = val.buttons;
  },
  HouseholdErrorModalShowModal(state, val) {
    state.HouseholdErrorModal.ShowModal = val.ShowModal;
    state.HouseholdErrorModal.errors = val.errors;
  },
  EditHouseholdModalShowModal(state, val) {
    state.EditHouseholdModal.ShowModal = val.ShowModal;
    state.EditHouseholdModal.Description = val.Description;
    state.EditHouseholdModal.buttons = val.buttons;
    state.EditHouseholdModal.member = val.member;
  },
  DeleteHouseholdModalShowModal(state, val) {
    state.DeleteHouseholdModal.ShowModal = val.ShowModal;
    state.DeleteHouseholdModal.Description = val.Description;
    state.DeleteHouseholdModal.buttons = val.buttons;
    state.DeleteHouseholdModal.member = val.member;
  },
  updateShowResultsPanel(state, val) {
    return (state.ShowResultPanel = val);
  },
  openPrintOfferModal: function(state, request) {
    state.printOfferModalInfo = request;
  },
  updateContactShowroomOrDeliveryVisitStatus: function(state, data) {
    state.ContactHasActiveShowroomOrDeliveryVisit = data;
  },
  updateHouseholdCoBuyerModalInfo(state, data) {
    state.HouseholdCoBuyerModalInfo = data;
  },
  updateDuplicateHouseholdMembersModal(state, data) {
    state.DuplicateHouseholdMemberModalInfo = data;
  },
  updateHouseholdCoBuyerSpinner(state, data) {
    state.HouseholdCoBuyerUpdateSpinner = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Contact.js